/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Live_Forgotten_TitleInputs */

const en_us2_workout_live_forgotten_title = /** @type {(inputs: Workout_Live_Forgotten_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Left your workout open?`)
};

const pt_br2_workout_live_forgotten_title = /** @type {(inputs: Workout_Live_Forgotten_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esqueceu o treino aberto?`)
};

const es_419_workout_live_forgotten_title = /** @type {(inputs: Workout_Live_Forgotten_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Dejaste el entrenamiento abierto?`)
};

const pt_pt2_workout_live_forgotten_title = /** @type {(inputs: Workout_Live_Forgotten_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esqueceste-te do treino aberto?`)
};

const fr_fr2_workout_live_forgotten_title = /** @type {(inputs: Workout_Live_Forgotten_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Séance restée ouverte ?`)
};

const de_de2_workout_live_forgotten_title = /** @type {(inputs: Workout_Live_Forgotten_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Training offen gelassen?`)
};

const it_it2_workout_live_forgotten_title = /** @type {(inputs: Workout_Live_Forgotten_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hai lasciato l'allenamento aperto?`)
};

/**
* | output |
* | --- |
* | "Left your workout open?" |
*
* @param {Workout_Live_Forgotten_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_live_forgotten_title = /** @type {((inputs?: Workout_Live_Forgotten_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Live_Forgotten_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_live_forgotten_title(inputs)
	if (locale === "es-419") return es_419_workout_live_forgotten_title(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_live_forgotten_title(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_live_forgotten_title(inputs)
	if (locale === "de-DE") return de_de2_workout_live_forgotten_title(inputs)
	if (locale === "it-IT") return it_it2_workout_live_forgotten_title(inputs)
	return en_us2_workout_live_forgotten_title(inputs)
});
export { workout_live_forgotten_title as "workout-live.forgotten_title" }